//Margin conventions
var margin = {top: 0, right: 0, bottom: 25, left: 40};

var widther = d3.select(".gia-chart").node().clientWidth;

var width = widther - margin.left - margin.right,
    height = 320 - margin.top - margin.bottom;

//Parses date for correct time format
var parseDate = d3.time.format("%b-%y").parse;  

//Appends the svg to the chart-container div
var svg = d3.select(".gia-chart").append("svg")
	.attr("width", width + margin.left + margin.right)
	.attr("height", height + margin.top + margin.bottom)
	.append("g")
	.attr("transform", "translate(" + margin.left + "," + margin.top + ")");

//Creates the xScale 
var xScale = d3.time.scale()
  .range([0, width]);

//Creates the yScale
var yScale = d3.scale.linear()
  .range([height, 0]);

//Color scale
var color = d3.scale.ordinal()
  .domain(["Fair", "Weak", "Contested", "Disproved", "Fair NCSR", "Confirmed"])
  .range(["#005689", "#4bc6df", "#ffbb00", "#e6711b", "#bdbdbd", "#333333"]);  

//Defines the y axis styles
var yAxis = d3.svg.axis()
	.scale(yScale)
  .tickSize(-width)
  .tickPadding(8)
	.orient("left");

//Defines the y axis styles
var xAxis = d3.svg.axis()
	.scale(xScale)
  .tickPadding(4)
	.orient("bottom")
  .ticks(4)
  .tickFormat(d3.time.format("%Y")); 

//line function convention (feeds an array)
var stack = d3.layout.stack()
  .offset("zero")
  .values(function(d) { return d.values;})
  .x(function(d) { return d.date;})
  .y(function(d) { return d.count;});

var nest = d3.nest()
  .key(function(d) { return d.type;});

var area = d3.svg.area()
    .interpolate("cardinal")
    .x(function(d) { return xScale(d.date); })
    .y0(function(d) { return yScale(d.y0); })
    .y1(function(d) { return yScale(d.y0 + d.y); });     

//Loads the data
d3.csv("data/airstrikes.csv", ready);

function ready(err, data) {

	if (err) throw "error loading data";

	//FORMAT data
	data.forEach(function(d) {
		d.count = +d.count;
    d.date = parseDate(d.date);
	});
	
	//Organizes the data	
  var maxY = d3.max(data, function(d) { return d.count; });

  var layers = stack(nest.entries(data));

  //Defines the xScale max
  xScale.domain(d3.extent(data, function(d) { return d.date; }));

  //Defines the yScale max
  yScale.domain([0, d3.max(data, function(d) { return d.y0 + d.y; })]);

	//Appends the x axis		
	var xAxisGroup = svg.append("g")
		.attr("class", "x axis")
		.attr("transform", "translate(0," + height + ")")
		.call(xAxis);  

  //Appends the y axis
  var yAxisGroup = svg.append("g")
    .attr("class", "y axis")
    .call(yAxis)
    .selectAll("g")
    .classed("g-baseline", function(d) {return d == 0}); 

  //Binds the data to the line
  var drawArea = svg.selectAll(".layer")
    .data(layers)
    .enter()
    .append("path")
    .attr("class", "layer")
    .attr("d", function(d) { return area(d.values);})
    .style("fill", function(d) { return color(d.key);});       	

//RESPONSIVENESS
  d3.select(window).on("resize", resized);

  function resized() {

    //new margin
    var newMargin = {top: 0, right: 0, bottom: 25, left: 40};

    var newWidther = d3.select(".gia-chart").node().clientWidth;

    var newWidth = newWidther - newMargin.left - newMargin.right;

    //Change the width of the svg
    d3.select("svg")
      .attr("width", newWidth + newMargin.left + newMargin.right);

    //Change the xScale
    xScale
      .range([0, newWidth]);

    //Change the area  
    stack
      .x(function(d) { return d.date;})
      .y(function(d) { return d.count;});

    area
      .x(function(d) { return xScale(d.date); });  

    drawArea
      .attr("d", function(d) { return area(d.values);})
      .style("fill", function(d) { return color(d.key);});  
    
    //Updates xAxis
    d3.selectAll(".x.axis")
         .call(xAxis);     

    //Updates ticks
    xAxis
      .scale(xScale);

    //Updates yAxis
    d3.selectAll(".y.axis")
      .call(yAxis); 

    yAxis
      .tickSize(-newWidth);
      
  };

}